import { render, staticRenderFns } from "./PostsFilters.vue?vue&type=template&id=9c0d992a&scoped=true"
import script from "./PostsFilters.vue?vue&type=script&lang=js"
export * from "./PostsFilters.vue?vue&type=script&lang=js"
import style0 from "./PostsFilters.vue?vue&type=style&index=0&id=9c0d992a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0d992a",
  null
  
)

export default component.exports